import { Show, TabbedShowLayout, useRecordContext, type ShowProps } from "react-admin";
import { ProjectShowToolbar } from "./show/ProjectShowToolbar";
import { ProjectShowOverview } from "./show/ProjectShowOverview";
import { ProjectShowTakhmeenTab } from "./show/ProjectShowTakhmeenTab";
import { ProjectShowReceiptsTab } from "./show/ProjectShowReceiptsTab";
import { ProjectShowInayatTab } from "./show/ProjectShowInayatTab";
import { ProjectShowKarzanTab } from "./show/ProjectShowKarzanTab";
import { ProjectShowRepaymentsTab } from "./show/ProjectShowRepaymentsTab";
import { ProjectShowPaymentsTab } from "./show/ProjectShowPaymentsTab";

const ProjectShowTitle = () => {
  const record = useRecordContext<{ name?: string }>();
  return <span>{record?.name ? record.name : ""}</span>;
};

export const ProjectShow = (props: ShowProps) => (
  <Show actions={<ProjectShowToolbar />} title={<ProjectShowTitle />} {...props}>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Overview">
        <ProjectShowOverview />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Takhmeen" path="takhmeen">
        <ProjectShowTakhmeenTab />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Receipts" path="receipts">
        <ProjectShowReceiptsTab />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Inayat" path="inayat">
        <ProjectShowInayatTab />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Work payments" path="payments">
        <ProjectShowPaymentsTab />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Karzan" path="karzan">
        <ProjectShowKarzanTab />
      </TabbedShowLayout.Tab>
      <TabbedShowLayout.Tab label="Repayments" path="repayments">
        <ProjectShowRepaymentsTab />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
